// Componente para el icono de TikTok SVG
export const TikTokIcon = ({ className = "" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 48 48" 
    width="1em" 
    height="1em"
    className={className}
  >
    <path fill="#3dd9eb" d="M20,37c2.761,0,5-2.239,5-5v-1v-1V6.07h5.208c-0.031-0.14-0.072-0.276-0.097-0.419H30.11 c-0.044-0.248-0.076-0.495-0.099-0.746V4.07H23V28v1v1c0,2.761-2.239,5-5,5c-0.864,0-1.665-0.239-2.375-0.625 C16.473,35.931,18.103,37,20,37z"/>
    <path fill="#f55376" d="M33.718,11.407c-0.797-1.094-1.364-2.367-1.607-3.756H32.11c-0.044-0.248-0.076-0.495-0.099-0.746 V6.07h-1.803C30.699,8.252,31.969,10.132,33.718,11.407z"/>
    <path fill="#f55376" d="M18,25c-2.761,0-5,2.239-5,5c0,1.897,1.069,3.527,2.625,4.375C15.239,33.665,15,32.864,15,32 c0-2.761,2.239-5,5-5c0.343,0,0.677,0.035,1,0.101v-7.05C20.669,20.023,20.338,20,20,20s-0.669,0.023-1,0.05v5.05 C18.677,25.035,18.343,25,18,25z"/>
    <path fill="#3dd9eb" d="M36.257,13.783c0.867,0.541,1.819,0.908,2.806,1.131v-0.376v-0.002v-1.381 c-1.7,0.003-3.364-0.473-4.806-1.373c-0.186-0.116-0.361-0.247-0.538-0.376C34.406,12.351,35.263,13.163,36.257,13.783z"/>
    <path fill="#3dd9eb" d="M19,20.05v-2C18.669,18.023,18.338,18,18,18c-6.627,0-12,5.373-12,12 c0,3.824,1.795,7.222,4.581,9.419C8.969,37.377,8,34.804,8,32C8,25.71,12.842,20.56,19,20.05z"/>
    <path fill="#f55376" d="M39.062,14.914v4.733c-3.375,0-6.501-1.071-9.052-2.894L30.013,30l-0.014-0.018 C29.999,29.988,30,29.994,30,30c0,6.627-5.373,12-12,12c-2.804,0-5.377-0.969-7.419-2.581C12.778,42.205,16.176,44,20,44 c6.627,0,12-5.373,12-12c0-0.006-0.001-0.012-0.001-0.018L32.013,32l-0.002-13.248c2.551,1.823,5.677,2.894,9.052,2.894v-5.108 v-0.002v-1.381C40.385,15.157,39.717,15.061,39.062,14.914z"/>
    <path fill="#2100c4" d="M30,30c0-0.006-0.001-0.012-0.001-0.018L30.013,30l-0.002-13.248 c2.551,1.823,5.677,2.894,9.052,2.894v-4.733c-0.987-0.223-1.939-0.59-2.806-1.131c-0.994-0.62-1.851-1.432-2.538-2.376 c-1.75-1.275-3.019-3.155-3.51-5.337H25V30v1v1c0,2.761-2.239,5-5,5c-1.897,0-3.527-1.069-4.375-2.625 C14.069,33.527,13,31.897,13,30c0-2.761,2.239-5,5-5c0.343,0,0.677,0.035,1,0.101v-5.05C12.842,20.56,8,25.71,8,32 c0,2.804,0.969,5.377,2.581,7.419C12.623,41.031,15.196,42,18,42C24.627,42,30,36.627,30,30z"/>
  </svg>
)

// Lista de iconos disponibles
export const iconosDisponibles = [
  // Redes sociales principales
  { id: 'facebook', clase: 'fab fa-facebook', nombre: 'Facebook', tipo: 'fontawesome' },
  { id: 'instagram', clase: 'fab fa-instagram', nombre: 'Instagram', tipo: 'fontawesome' },
  { id: 'twitter', clase: 'fab fa-twitter', nombre: 'Twitter', tipo: 'fontawesome' },
  { id: 'linkedin', clase: 'fab fa-linkedin', nombre: 'LinkedIn', tipo: 'fontawesome' },
  { id: 'whatsapp', clase: 'fab fa-whatsapp', nombre: 'WhatsApp', tipo: 'fontawesome' },
  { id: 'youtube', clase: 'fab fa-youtube', nombre: 'YouTube', tipo: 'fontawesome' },
  { id: 'tiktok', nombre: 'TikTok', tipo: 'svg', componente: TikTokIcon },
  { id: 'pinterest', clase: 'fab fa-pinterest', nombre: 'Pinterest', tipo: 'fontawesome' },
  { id: 'snapchat', clase: 'fab fa-snapchat', nombre: 'Snapchat', tipo: 'fontawesome' },
  { id: 'telegram', clase: 'fab fa-telegram', nombre: 'Telegram', tipo: 'fontawesome' },
  { id: 'discord', clase: 'fab fa-discord', nombre: 'Discord', tipo: 'fontawesome' },
  { id: 'twitch', clase: 'fab fa-twitch', nombre: 'Twitch', tipo: 'fontawesome' },
  { id: 'reddit', clase: 'fab fa-reddit', nombre: 'Reddit', tipo: 'fontawesome' },
  { id: 'spotify', clase: 'fab fa-spotify', nombre: 'Spotify', tipo: 'fontawesome' },
  
  // Plataformas profesionales
  { id: 'behance', clase: 'fab fa-behance', nombre: 'Behance', tipo: 'fontawesome' },
  { id: 'dribbble', clase: 'fab fa-dribbble', nombre: 'Dribbble', tipo: 'fontawesome' },
  { id: 'github', clase: 'fab fa-github', nombre: 'GitHub', tipo: 'fontawesome' },
  { id: 'medium', clase: 'fab fa-medium', nombre: 'Medium', tipo: 'fontawesome' },
  { id: 'dev', clase: 'fab fa-dev', nombre: 'Dev.to', tipo: 'fontawesome' },
  
  // Tiendas y ecommerce
  { id: 'amazon', clase: 'fab fa-amazon', nombre: 'Amazon', tipo: 'fontawesome' },
  { id: 'etsy', clase: 'fab fa-etsy', nombre: 'Etsy', tipo: 'fontawesome' },
  { id: 'ebay', clase: 'fab fa-ebay', nombre: 'eBay', tipo: 'fontawesome' },
  { id: 'store', clase: 'fas fa-store', nombre: 'Tienda Online', tipo: 'fontawesome' },
  
  // Otros servicios
  { id: 'paypal', clase: 'fab fa-paypal', nombre: 'PayPal', tipo: 'fontawesome' },
  { id: 'stripe', clase: 'fab fa-stripe-s', nombre: 'Stripe', tipo: 'fontawesome' },
  { id: 'apple', clase: 'fab fa-apple', nombre: 'Apple', tipo: 'fontawesome' },
  { id: 'google', clase: 'fab fa-google', nombre: 'Google', tipo: 'fontawesome' },
  { id: 'microsoft', clase: 'fab fa-microsoft', nombre: 'Microsoft', tipo: 'fontawesome' },
  { id: 'skype', clase: 'fab fa-skype', nombre: 'Skype', tipo: 'fontawesome' },
  { id: 'video', clase: 'fas fa-video', nombre: 'Videoconferencia', tipo: 'fontawesome' },
  { id: 'vimeo', clase: 'fab fa-vimeo', nombre: 'Vimeo', tipo: 'fontawesome' },
  
  // Iconos generales
  { id: 'email', clase: 'fas fa-envelope', nombre: 'Email', tipo: 'fontawesome' },
  { id: 'phone', clase: 'fas fa-phone', nombre: 'Teléfono', tipo: 'fontawesome' },
  { id: 'globe', clase: 'fas fa-globe', nombre: 'Sitio Web', tipo: 'fontawesome' },
  { id: 'link', clase: 'fas fa-link', nombre: 'Enlace', tipo: 'fontawesome' },
  { id: 'shopping', clase: 'fas fa-shopping-cart', nombre: 'Tienda', tipo: 'fontawesome' },
  { id: 'briefcase', clase: 'fas fa-briefcase', nombre: 'Trabajo', tipo: 'fontawesome' },
  { id: 'camera', clase: 'fas fa-camera', nombre: 'Fotografía', tipo: 'fontawesome' },
  { id: 'music', clase: 'fas fa-music', nombre: 'Música', tipo: 'fontawesome' },
  { id: 'film', clase: 'fas fa-video', nombre: 'Video', tipo: 'fontawesome' },
  { id: 'gamepad', clase: 'fas fa-gamepad', nombre: 'Juegos', tipo: 'fontawesome' },
  { id: 'book', clase: 'fas fa-book', nombre: 'Blog', tipo: 'fontawesome' },
  { id: 'heart', clase: 'fas fa-heart', nombre: 'Favoritos', tipo: 'fontawesome' },
  { id: 'home', clase: 'fas fa-home', nombre: 'Inicio', tipo: 'fontawesome' },
  { id: 'star', clase: 'fas fa-star', nombre: 'Destacado', tipo: 'fontawesome' },
  
  // Iconos bancarios
  { id: 'bank', clase: 'fas fa-university', nombre: 'Banco', tipo: 'fontawesome' },
  { id: 'credit-card', clase: 'fas fa-credit-card', nombre: 'Tarjeta', tipo: 'fontawesome' },
  { id: 'money-transfer', clase: 'fas fa-exchange-alt', nombre: 'Transferencia', tipo: 'fontawesome' },
  { id: 'wallet', clase: 'fas fa-wallet', nombre: 'Billetera', tipo: 'fontawesome' },
  { id: 'donate', clase: 'fas fa-donate', nombre: 'Donación', tipo: 'fontawesome' },
  { id: 'piggy-bank', clase: 'fas fa-piggy-bank', nombre: 'Ahorro', tipo: 'fontawesome' }
]

// Divisas disponibles
export const divisas = [
  { codigo: 'USD', nombre: 'Dólar Estadounidense', simbolo: '$' },
  { codigo: 'EUR', nombre: 'Euro', simbolo: '€' },
  { codigo: 'MXN', nombre: 'Peso Mexicano', simbolo: '$' },
  { codigo: 'ARS', nombre: 'Peso Argentino', simbolo: '$' },
  { codigo: 'COP', nombre: 'Peso Colombiano', simbolo: '$' },
  { codigo: 'PEN', nombre: 'Sol Peruano', simbolo: 'S/' },
  { codigo: 'CLP', nombre: 'Peso Chileno', simbolo: '$' },
  { codigo: 'BRL', nombre: 'Real Brasileño', simbolo: 'R$' },
  { codigo: 'UYU', nombre: 'Peso Uruguayo', simbolo: '$' },
  { codigo: 'BOB', nombre: 'Boliviano', simbolo: 'Bs' },
  { codigo: 'GTQ', nombre: 'Quetzal Guatemalteco', simbolo: 'Q' },
  { codigo: 'CRC', nombre: 'Colón Costarricense', simbolo: '₡' },
  { codigo: 'PAB', nombre: 'Balboa Panameño', simbolo: 'B/.' },
  { codigo: 'HNL', nombre: 'Lempira Hondureño', simbolo: 'L' },
  { codigo: 'NIO', nombre: 'Córdoba Nicaragüense', simbolo: 'C$' },
  { codigo: 'VES', nombre: 'Bolívar Venezolano', simbolo: 'Bs.S' },
  { codigo: 'GBP', nombre: 'Libra Esterlina', simbolo: '£' },
  { codigo: 'CAD', nombre: 'Dólar Canadiense', simbolo: 'C$' }
]

// Países disponibles para cuentas bancarias
export const paisesBancarios = [
  { codigo: 'MX', nombre: 'México', campoAdicional: 'CLABE' },
  { codigo: 'AR', nombre: 'Argentina', campoAdicional: 'CBU' },
  { codigo: 'CO', nombre: 'Colombia', campoAdicional: 'Número de Cuenta' },
  { codigo: 'PE', nombre: 'Perú', campoAdicional: 'CCI' },
  { codigo: 'CL', nombre: 'Chile', campoAdicional: 'Número de Cuenta' },
  { codigo: 'BR', nombre: 'Brasil', campoAdicional: 'Código del Banco' },
  { codigo: 'UY', nombre: 'Uruguay', campoAdicional: 'Número de Cuenta' },
  { codigo: 'EC', nombre: 'Ecuador', campoAdicional: 'Número de Cuenta' },
  { codigo: 'US', nombre: 'Estados Unidos', campoAdicional: 'Routing Number' },
  { codigo: 'ES', nombre: 'España', campoAdicional: 'IBAN' },
  { codigo: 'OTHER', nombre: 'Otro País', campoAdicional: 'Código Adicional' }
]

// Códigos de país para WhatsApp
export const codigosPais = [
  { codigo: '+1', nombre: 'Estados Unidos/Canadá', bandera: '🇺🇸' },
  { codigo: '+52', nombre: 'México', bandera: '🇲🇽' },
  { codigo: '+54', nombre: 'Argentina', bandera: '🇦🇷' },
  { codigo: '+56', nombre: 'Chile', bandera: '🇨🇱' },
  { codigo: '+57', nombre: 'Colombia', bandera: '🇨🇴' },
  { codigo: '+51', nombre: 'Perú', bandera: '🇵🇪' },
  { codigo: '+55', nombre: 'Brasil', bandera: '🇧🇷' },
  { codigo: '+598', nombre: 'Uruguay', bandera: '🇺🇾' },
  { codigo: '+593', nombre: 'Ecuador', bandera: '🇪🇨' },
  { codigo: '+591', nombre: 'Bolivia', bandera: '🇧🇴' },
  { codigo: '+595', nombre: 'Paraguay', bandera: '🇵🇾' },
  { codigo: '+58', nombre: 'Venezuela', bandera: '🇻🇪' },
  { codigo: '+34', nombre: 'España', bandera: '🇪🇸' },
  { codigo: '+33', nombre: 'Francia', bandera: '🇫🇷' },
  { codigo: '+49', nombre: 'Alemania', bandera: '🇩🇪' },
  { codigo: '+44', nombre: 'Reino Unido', bandera: '🇬🇧' },
  { codigo: '+39', nombre: 'Italia', bandera: '🇮🇹' }
]

// Tipos de enlaces disponibles
export const tiposEnlaces = [
  {
    id: 'normal',
    nombre: 'Enlace Normal',
    descripcion: 'Enlace básico a cualquier sitio web',
    icono: 'fas fa-link',
    color: 'blue'
  },
  {
    id: 'producto',
    nombre: 'Producto',
    descripcion: 'Enlace para vender productos con precio y descripción',
    icono: 'fas fa-shopping-cart',
    color: 'green'
  },
  {
    id: 'whatsapp',
    nombre: 'WhatsApp',
    descripcion: 'Enlace directo a WhatsApp con mensaje predefinido',
    icono: 'fab fa-whatsapp',
    color: 'success'
  },
  {
    id: 'cuenta_bancaria',
    nombre: 'Cuenta Bancaria',
    descripcion: 'Información bancaria para recibir transferencias',
    icono: 'fas fa-university',
    color: 'warning'
  },
  {
    id: 'ubicacion',
    nombre: 'Ubicación',
    descripcion: 'Enlace a ubicación en Google Maps',
    icono: 'fas fa-map-marker-alt',
    color: 'red'
  }
]

// Tipos de cuenta disponibles
export const tiposCuenta = [
  { id: 'ahorro', nombre: 'Cuenta de Ahorro' },
  { id: 'corriente', nombre: 'Cuenta Corriente' },
  { id: 'nomina', nombre: 'Cuenta Nómina' },
  { id: 'empresarial', nombre: 'Cuenta Empresarial' },
  { id: 'inversion', nombre: 'Cuenta de Inversión' },
  { id: 'otro', nombre: 'Otro Tipo' }
]

// Tipografías disponibles
export const tipografiasDisponibles = [
  { 
    id: 'inter', 
    nombre: 'Inter', 
    familia: '"Inter", system-ui, -apple-system, sans-serif',
    categoria: 'Sans Serif',
    descripcion: 'Moderna y legible, perfecta para contenido digital'
  },
  { 
    id: 'roboto', 
    nombre: 'Roboto', 
    familia: '"Roboto", system-ui, -apple-system, sans-serif',
    categoria: 'Sans Serif',
    descripcion: 'Diseñada por Google, muy versátil y clara'
  },
  { 
    id: 'poppins', 
    nombre: 'Poppins', 
    familia: '"Poppins", system-ui, -apple-system, sans-serif',
    categoria: 'Sans Serif',
    descripcion: 'Geométrica y amigable, perfecta para marcas jóvenes'
  },
  { 
    id: 'montserrat', 
    nombre: 'Montserrat', 
    familia: '"Montserrat", system-ui, -apple-system, sans-serif',
    categoria: 'Sans Serif',
    descripcion: 'Elegante y profesional, inspirada en la tipografía urbana'
  },
  { 
    id: 'opensans', 
    nombre: 'Open Sans', 
    familia: '"Open Sans", system-ui, -apple-system, sans-serif',
    categoria: 'Sans Serif',
    descripcion: 'Neutral y humanista, muy legible en pantallas'
  },
  { 
    id: 'playfair', 
    nombre: 'Playfair Display', 
    familia: '"Playfair Display", Georgia, serif',
    categoria: 'Serif',
    descripcion: 'Elegante y sofisticada, ideal para contenido premium'
  },
  { 
    id: 'merriweather', 
    nombre: 'Merriweather', 
    familia: '"Merriweather", Georgia, serif',
    categoria: 'Serif',
    descripcion: 'Diseñada para pantallas, muy legible en texto largo'
  },
  { 
    id: 'lora', 
    nombre: 'Lora', 
    familia: '"Lora", Georgia, serif',
    categoria: 'Serif',
    descripcion: 'Cálida y amigable, perfecta para blogs y contenido'
  },
  { 
    id: 'firacode', 
    nombre: 'Fira Code', 
    familia: '"Fira Code", Consolas, monospace',
    categoria: 'Monospace',
    descripcion: 'Técnica y moderna, ideal para perfiles de desarrolladores'
  },
  { 
    id: 'jetbrains', 
    nombre: 'JetBrains Mono', 
    familia: '"JetBrains Mono", Consolas, monospace',
    categoria: 'Monospace',
    descripcion: 'Optimizada para código, clara y distintiva'
  },
  { 
    id: 'system', 
    nombre: 'Sistema', 
    familia: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    categoria: 'Sistema',
    descripcion: 'Usa la fuente nativa del dispositivo, rápida y familiar'
  }
]

// Paletas de colores disponibles
export const paletasColores = [
  {
    id: 'default',
    nombre: 'Océano Clásico',
    categoria: 'Clásica',
    descripcion: 'Azules tranquilos y profesionales',
    colores: {
      primario: '#3B82F6',
      secundario: '#1E40AF', 
      acento: '#06B6D4',
      fondo: 'linear-gradient(135deg, #f8fafc, #e2e8f0)',
      fondoSecundario: '#ffffff',
      texto: '#1F2937',
      textoSecundario: '#6B7280',
      borde: '#E5E7EB'
    }
  },
  {
    id: 'sunset',
    nombre: 'Atardecer Cálido',
    categoria: 'Cálida',
    descripcion: 'Naranjas y rojos vibrantes como un atardecer',
    colores: {
      primario: '#F97316',
      secundario: '#EA580C',
      acento: '#FBBF24',
      fondo: 'linear-gradient(135deg, #fef3e2, #fed7aa)',
      fondoSecundario: '#ffffff',
      texto: '#7C2D12',
      textoSecundario: '#9A3412',
      borde: '#FDBA74'
    }
  },
  {
    id: 'forest',
    nombre: 'Bosque Sereno',
    categoria: 'Natural',
    descripcion: 'Verdes naturales y relajantes',
    colores: {
      primario: '#059669',
      secundario: '#047857',
      acento: '#34D399',
      fondo: 'linear-gradient(135deg, #f0fdf4, #dcfce7)',
      fondoSecundario: '#ffffff',
      texto: '#064E3B',
      textoSecundario: '#065F46',
      borde: '#A7F3D0'
    }
  },
  {
    id: 'lavender',
    nombre: 'Lavanda Suave',
    categoria: 'Pastel',
    descripcion: 'Púrpuras suaves y elegantes',
    colores: {
      primario: '#8B5CF6',
      secundario: '#7C3AED',
      acento: '#A78BFA',
      fondo: 'linear-gradient(135deg, #faf5ff, #f3e8ff)',
      fondoSecundario: '#ffffff',
      texto: '#581C87',
      textoSecundario: '#6B21A8',
      borde: '#C4B5FD'
    }
  },
  {
    id: 'rose',
    nombre: 'Rosa Elegante',
    categoria: 'Romántica',
    descripcion: 'Rosas sofisticados y femeninos',
    colores: {
      primario: '#F43F5E',
      secundario: '#E11D48',
      acento: '#FB7185',
      fondo: 'linear-gradient(135deg, #fef7f7, #fecaca)',
      fondoSecundario: '#ffffff',
      texto: '#881337',
      textoSecundario: '#9F1239',
      borde: '#FCA5A5'
    }
  },
  {
    id: 'midnight',
    nombre: 'Medianoche',
    categoria: 'Oscura',
    descripcion: 'Elegancia oscura con acentos brillantes',
    colores: {
      primario: '#3B82F6',
      secundario: '#1E40AF',
      acento: '#60A5FA',
      fondo: 'linear-gradient(135deg, #1e293b, #0f172a)',
      fondoSecundario: '#334155',
      texto: '#F1F5F9',
      textoSecundario: '#CBD5E1',
      borde: '#475569'
    }
  },
  {
    id: 'golden',
    nombre: 'Dorado Real',
    categoria: 'Lujosa',
    descripcion: 'Dorados y marrones lujosos',
    colores: {
      primario: '#D97706',
      secundario: '#B45309',
      acento: '#FBBF24',
      fondo: 'linear-gradient(135deg, #fffbeb, #fef3c7)',
      fondoSecundario: '#ffffff',
      texto: '#78350F',
      textoSecundario: '#92400E',
      borde: '#FCD34D'
    }
  },
  {
    id: 'coral',
    nombre: 'Coral Tropical',
    categoria: 'Vibrante',
    descripcion: 'Corales y turquesas tropicales',
    colores: {
      primario: '#FF6B6B',
      secundario: '#EE5A52',
      acento: '#4ECDC4',
      fondo: 'linear-gradient(135deg, #fef2f2, #fecaca)',
      fondoSecundario: '#ffffff',
      texto: '#7F1D1D',
      textoSecundario: '#991B1B',
      borde: '#FCA5A5'
    }
  },
  {
    id: 'mint',
    nombre: 'Menta Fresca',
    categoria: 'Fresca',
    descripcion: 'Verdes menta refrescantes',
    colores: {
      primario: '#10B981',
      secundario: '#059669',
      acento: '#6EE7B7',
      fondo: 'linear-gradient(135deg, #f0fdfa, #ccfbf1)',
      fondoSecundario: '#ffffff',
      texto: '#064E3B',
      textoSecundario: '#065F46',
      borde: '#99F6E4'
    }
  },
  {
    id: 'neon',
    nombre: 'Neón Cyber',
    categoria: 'Futurista',
    descripcion: 'Colores neón vibrantes y futuristas',
    colores: {
      primario: '#8B5CF6',
      secundario: '#7C3AED',
      acento: '#06FFA5',
      fondo: 'linear-gradient(135deg, #0c0a09, #18181b)',
      fondoSecundario: '#27272a',
      texto: '#FAFAFA',
      textoSecundario: '#A1A1AA',
      borde: '#52525b'
    }
  },
  {
    id: 'autumn',
    nombre: 'Otoño Cálido',
    categoria: 'Estacional',
    descripcion: 'Colores cálidos del otoño',
    colores: {
      primario: '#DC2626',
      secundario: '#B91C1C',
      acento: '#F59E0B',
      fondo: 'linear-gradient(135deg, #fef2f2, #fed7aa)',
      fondoSecundario: '#ffffff',
      texto: '#7F1D1D',
      textoSecundario: '#92400E',
      borde: '#FCA5A5'
    }
  },
  {
    id: 'sky',
    nombre: 'Cielo Despejado',
    categoria: 'Aérea',
    descripcion: 'Azules cielo y nubes blancas',
    colores: {
      primario: '#0EA5E9',
      secundario: '#0284C7',
      acento: '#7DD3FC',
      fondo: 'linear-gradient(135deg, #f0f9ff, #e0f2fe)',
      fondoSecundario: '#ffffff',
      texto: '#0C4A6E',
      textoSecundario: '#075985',
      borde: '#BAE6FD'
    }
  }
] 